module.exports = __webpack_public_path__ + "static/media/Logo.cdc27d26.svg";